import React from 'react';

const EMPTY_HTML = '<!doctype html><html><body></body></html>';

export default function HtmlResourcePreview({ html, title = 'HTML resource preview', className = '' }) {
  return (
    <iframe
      title={title}
      srcDoc={html || EMPTY_HTML}
      sandbox=""
      referrerPolicy="no-referrer"
      className={`tw-block tw-w-full tw-h-full tw-border-0 tw-bg-white ${className}`}
    />
  );
}
